import React, { useContext, useState } from "react";
import { Typography, Button, Box } from "@material-ui/core";
import { Timeline } from "@material-ui/lab";
import TimelineCard from "./TimelineCard";
import Loading from "../common/Loading";
import { AppContext } from "../../context/reducer";
import FullTextDialog from "./FullTextDialog";
import { useHistory } from "react-router-dom";

const TimeLineConnector = () => {
  const [isFullCardOpen, setIsFullCardOpen] = useState(false);
  const [newsDetail, setNewsDetail] = useState({});
  const { state } = useContext(AppContext);

  const handleDialog = () => setIsFullCardOpen((oldState) => !oldState);

  let history = useHistory();

  return (
    <Box p={2}>
      <FullTextDialog
        open={isFullCardOpen}
        onClose={handleDialog}
        {...newsDetail}
      />
      <div style={{ display: "flex", alignItems: "baseline" }}>
        <Typography
          variant="h4"
          gutterBottom
          style={{ paddingBottom: 20, flex: 1 }}
        >
          {window.t["News"]}
        </Typography>
        <Button onClick={() => history.push("/news")} color="primary">
          {window.t["View all"]}
        </Button>
      </div>
      {state.loading ? (
        <Loading />
      ) : (
        <>
          {!state.posts.length && (
            <Typography variant="body2">
              {window.t["No posts were found"]}
            </Typography>
          )}
          <Timeline align="alternate">
            {state.posts.length > 0 &&
              state.posts.map((post, i) => (
                <TimelineCard
                  key={i}
                  postInfo={{
                    ...post,
                    onClick: () => {
                      setNewsDetail({ ...post });
                      handleDialog();
                    },
                  }}
                  position={i}
                  length={state.posts.length}
                />
              ))}
          </Timeline>
        </>
      )}
    </Box>
  );
};

export default TimeLineConnector;
